const LOGIN = "/auth/login",
    REGISTER_URL = '/auth/register',
    WINERIES = '/wineries',
    RESET = '/reset',
    WINELABELS = '/winelabels',
    VARIETIES = '/varieties',
    LABELS = '/labels',
    TANKS = '/tanks',
    SENSORS = '/sensors',
    OPERATIONS = '/operations',
    NOTE = '/note',
    USER = '/user',
    USERS = '/users',
    LOTS = '/batches',
    TRACKING = '/tracking',
    TREE = '/tree',
    PROTOCOLS = '/protocols',
    UPLOAD_DATASHEET = '/upload_datasheet',
    RESULTS = '/results',
    RECURRENT = '/recurrent',
    DRUGS = '/drugs',
    WAREHOUSE = '/warehouse',
    CAPS = '/caps',
    ANALYSIS = '/analysis',
    CLIENTS = '/clients',
    WINEMAKING = '/winemaking',
    OIV = '/oiv',
    SUBSTANCES = '/SUBSTANCES',
    STATE = '/state',
    START = '/start',
    WORK_MODE = '/work_mode',
    APPLY = '/apply',
    UTILS = '/utils',
    REPORT = '/report',
    COOKIE = '/cookie',
    HISTORY = '/history',
    COUNT = '/count',
    EXPIRED = '/expired',
    UNITS='/units',
    UPDATE='/update',
    SETTINGS='/settings',
    PERMISSIONS='/permissions',
    EMAIL='/email',
    QR='/qr',
    NEW_PASSWORD='/new-password',
    PDF = '/create-pdf',
    EXCEL = '/create-excel',
    DICTIONARY = '/dictionary',
    TOKEN_KEY = 'auth',
    STICKY_NOTE = '/sticky-note',
    CLOSE = '/CLOSE',
    BUYERS = '/buyers',
    POMACES = '/pomaces'

export {
    LOGIN,
    REGISTER_URL,
    TOKEN_KEY,
    WINERIES,
    RESET,
    WINELABELS,
    LABELS,
    VARIETIES,
    TANKS,
    SENSORS,
    LOTS,
    OPERATIONS,
    NOTE,
    PROTOCOLS,
    UPLOAD_DATASHEET,
    RESULTS,
    RECURRENT,
    USERS,
    USER,
    DRUGS,
    WAREHOUSE,
    CAPS,
    ANALYSIS,
    CLIENTS,
    WINEMAKING,
    OIV,
    SUBSTANCES,
    STATE,
    START,
    WORK_MODE,
    APPLY,
    HISTORY,
    COUNT,
    EXPIRED,
    UTILS,
    REPORT,
    COOKIE,
    TRACKING,
    TREE,
    UNITS,
    UPDATE,
    SETTINGS,
    EMAIL,
    QR,
    PERMISSIONS,
    NEW_PASSWORD,
    PDF,
    EXCEL,
    DICTIONARY,
    STICKY_NOTE,
    CLOSE,
    BUYERS,
    POMACES
}